"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TARGET_TOKEN = exports.INJECTOR_TOKEN = void 0;
exports.INJECTOR_TOKEN = '$injector';
exports.TARGET_TOKEN = '$target';
//# sourceMappingURL=InjectionToken.js.map